// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","container":"styles_container__2OhGC","logo":"styles_logo___i5Ey","bottom20":"styles_bottom20__PUO08","bottom90":"styles_bottom90__2WoPy"};